<div *ngIf="isMotor()">
  <div class="uk-container add-padding-top">
    <div class="uk-card uk-card-default payment-detail-card">
      <div class="uk-flex uk-flex-between@s header-container"
        *ngIf="display().logo || display().merchantName || display().ref1">
        <div>
          <div *ngIf="display().logo" class="header-image">
            <img [src]="display().logo" loading="lazy" alt="Logo" />
          </div>
        </div>
        <div class="uk-text-right@s header-content">
          <div *ngIf="display().merchantName" class="header-content-title">
            <span> {{display().merchantName }}</span>
          </div>
          <div *ngIf="display().ref1" class="header-content-sub-title">
            <span>Ref. No: {{display().ref1}}</span>
          </div>
        </div>
      </div>

      <div class="payment-detail-card-body">
        <h2 class="product-detail"> {{display().titleTH}} </h2>

        <div class="product-detail">
          <div class="label"> {{display().insuredTypeLabel}} </div>
          <div class="value"> {{display().insuredType}} </div>
        </div>
        <div class="product-detail">
          <div class="label"> {{display().insurerLabel}} </div>
          <div class="value"> {{display().insurer}} </div>
        </div>
        <div class="product-detail">
          <div class="label"> {{display().nameLabel}}</div>
          <div class="value"> {{display().name}}</div>
        </div>

        <div #paymentSectionStyle class="product-detail payment-section">
          <h3 id="label-amount">{{display().amountLabel}}</h3>
          <h1 id="display-amount">{{display().amount | number : '1.2-2'}} {{display().amountBahtLabel}}</h1>
        </div>

      </div>
      <div class="uk-flex uk-flex-center uk-padding-remove-horizontal product-detail payment-button">
        <button #btnSubmitPaymentStyle type="submit"
          class="uk-button uk-button-primary uk-button-medium uk-width-1-1 uk-border-rounded"
          [ngStyle]="{'background-color': style.Button}" (click)="runPayment()">
          {{display().checkoutBtnLabel}}
        </button>
      </div>
    </div>
  </div>
</div>

<app-tisco-modal></app-tisco-modal>
<div class="modal-waiting" *ngIf="loading()">
  <div class="uk-position-center">
    <div class="uk-padding-small uk-border-rounded">
      <span class="+tisco-text-white" uk-spinner="ratio: 4.5"></span>
    </div>
  </div>
</div>